var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    {
      ref: _vm.dialogRef,
      attrs: { id: "general-form-wrapper", "md-click-outside-to-close": false }
    },
    [
      _c(
        "md-dialog-actions",
        [
          _c(
            "md-button",
            {
              staticClass: "md-primary closeBtn",
              on: { click: _vm.closeDialog }
            },
            [_vm._v("X")]
          )
        ],
        1
      ),
      _c("div", { staticClass: "md-headline" }, [
        _vm.localExpiredObj.expiredDistribution &&
        _vm.localExpiredObj.expiredDistribution.length > 0
          ? _c(
              "div",
              [
                _c("h4", { staticClass: "title" }, [
                  _vm._v("Distribution expired")
                ]),
                _c("div", { staticClass: "details header" }, [
                  _c("p", [_vm._v("Name")]),
                  _c("p", [_vm._v("Expiration date")])
                ]),
                _vm._l(_vm.localExpiredObj.expiredDistribution, function(item) {
                  return _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "redirect info",
                        attrs: {
                          target: "_blank",
                          rel: "noopener noreferrer",
                          href: "distribution/" + item._id + "/edit"
                        }
                      },
                      [
                        _c("div", { staticClass: "details" }, [
                          _c("div", { staticClass: "justifyStart" }, [
                            _c("strong", [_vm._v(_vm._s(item.name))])
                          ]),
                          _c("div", { staticClass: "justifyStart" }, [
                            _c("span", { staticClass: "redColor" }, [
                              _vm._v(_vm._s(item.endDate.substring(0, 10)))
                            ])
                          ])
                        ])
                      ]
                    )
                  ])
                })
              ],
              2
            )
          : _vm._e(),
        _vm.localExpiredObj.expiredDistribution &&
        _vm.localExpiredObj.deadLineDistribution.length > 0
          ? _c(
              "div",
              [
                _c("h4", { staticClass: "title" }, [
                  _vm._v("Distribution near to expiration")
                ]),
                _c("div", { staticClass: "details header" }, [
                  _c("p", [_vm._v("Name")]),
                  _c("p", [_vm._v("Expiration date")])
                ]),
                _vm._l(_vm.localExpiredObj.deadLineDistribution, function(
                  item
                ) {
                  return _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "redirect info",
                        attrs: {
                          target: "_blank",
                          rel: "noopener noreferrer",
                          href: "distribution/" + item._id + "/edit"
                        }
                      },
                      [
                        _c("div", { staticClass: "details" }, [
                          _c("div", { staticClass: "justifyStart" }, [
                            _c("strong", [_vm._v(_vm._s(item.name))])
                          ]),
                          _c("div", { staticClass: "justifyStart" }, [
                            _c("span", { staticClass: "orangeColor" }, [
                              _vm._v(_vm._s(item.endDate.substring(0, 10)))
                            ])
                          ])
                        ])
                      ]
                    )
                  ])
                })
              ],
              2
            )
          : _vm._e(),
        _vm.localExpiredObj.expiredDistribution &&
        _vm.localExpiredObj.expiredLisenses.length > 0
          ? _c(
              "div",
              [
                _c("h4", { staticClass: "title" }, [
                  _vm._v("Licenses expired")
                ]),
                _c("div", { staticClass: "details header" }, [
                  _c("p", [_vm._v("Name")]),
                  _c("p", [_vm._v("Expiration date")])
                ]),
                _vm._l(_vm.localExpiredObj.expiredLisenses, function(item) {
                  return _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "redirect info",
                        attrs: {
                          target: "_blank",
                          rel: "noopener noreferrer",
                          href: "license/" + item._id
                        }
                      },
                      [
                        _c("div", { staticClass: "details" }, [
                          _c("div", { staticClass: "justifyStart" }, [
                            _c("strong", [_vm._v(_vm._s(item.name))])
                          ]),
                          _c("div", { staticClass: "justifyStart" }, [
                            _c("span", { staticClass: "redColor" }, [
                              _vm._v(_vm._s(item.endDate.substring(0, 10)))
                            ])
                          ])
                        ])
                      ]
                    )
                  ])
                })
              ],
              2
            )
          : _vm._e(),
        _vm.localExpiredObj.expiredDistribution &&
        _vm.localExpiredObj.deadLineLisenses.length > 0
          ? _c(
              "div",
              [
                _c("h4", { staticClass: "title" }, [
                  _vm._v("Licenses near to expiration")
                ]),
                _c("div", { staticClass: "details header" }, [
                  _c("p", [_vm._v("Name")]),
                  _c("p", [_vm._v("Expiration date")])
                ]),
                _vm._l(_vm.localExpiredObj.deadLineLisenses, function(item) {
                  return _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "redirect info",
                        attrs: {
                          target: "_blank",
                          rel: "noopener noreferrer",
                          href: "license/" + item._id
                        }
                      },
                      [
                        _c("div", { staticClass: "details" }, [
                          _c("div", { staticClass: "justifyStart" }, [
                            _c("strong", [_vm._v(_vm._s(item.name))])
                          ]),
                          _c("div", { staticClass: "justifyStart" }, [
                            _c("span", { staticClass: "orangeColor" }, [
                              _vm._v(_vm._s(item.endDate.substring(0, 10)))
                            ])
                          ])
                        ])
                      ]
                    )
                  ])
                })
              ],
              2
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71466d0e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71466d0e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/marketplace/expiredDistributionDialog.vue
// module id = 673
// module chunks = 0